export default {
  snippets: [],
  labels: {
    items: [],
    active: {},
    edit: {
      name: ''
    },
  },
  labelSnippets: {
    items: [],
    active: {},
    mode: '',
    edit: {
      title: '',
      description: '',
      label: '',
      snippetFiles: []
    }
  },
  languages: {},
  flags: {
    ready: false,
    renderAllSnippets: false,
    scrollToLatestFile: false
  }
}
